import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Upload(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Upload", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M29.7845 13.1581c-.9284 0-1.7537.2063-2.4758.4126C26.1739 10.3727 23.079 8 19.4684 8c-4.2296 0-7.7371 3.198-8.1498 7.3245-.4126-.1032-.7221-.1032-1.1348-.1032-3.4043 0-6.18966 2.7854-6.18966 6.1897s2.78536 6.1897 6.18966 6.1897h19.6007c4.0233 0 7.2214-3.198 7.2214-7.2213 0-4.0233-3.1981-7.2213-7.2214-7.2213Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m19.469 17.2847-6.1897 6.1897h3.0948v8.2529h6.1897v-8.2529h3.0949l-6.1897-6.1897Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.9754 39.98c4.558 0 8.2529-3.695 8.2529-8.253 0-4.5579-3.6949-8.2529-8.2529-8.2529s-8.2529 3.695-8.2529 8.2529c0 4.558 3.6949 8.253 8.2529 8.253Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.973 32.7589c-.6189 0-1.0316-.4126-1.0316-1.0316v-5.1581c0-.619.4127-1.0316 1.0316-1.0316.619 0 1.0316.4126 1.0316 1.0316v5.1581c0 .619-.4126 1.0316-1.0316 1.0316Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M40.0995 32.7581H35.973c-.6189 0-1.0316-.4127-1.0316-1.0317 0-.6189.4127-1.0316 1.0316-1.0316h4.1265c.619 0 1.0316.4127 1.0316 1.0316 0 .619-.4126 1.0317-1.0316 1.0317Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Upload.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Upload"
};
validateTidalLicense();
export {
  Upload
};
//# sourceMappingURL=Upload.js.map
